import React from 'react';

function InspectionPhotoField({ answer, readOnly, onUpload, onDelete }) {
  const aid = answer?.id;
  const images = answer?.images || [];

  return (
    <div className="inspection-q-photo">
      {!readOnly && aid && (
        <input
          type="file"
          accept="image/*"
          className="form-control form-control-sm"
          onChange={(e) => {
            const f = e.target.files?.[0];
            e.target.value = '';
            onUpload(aid, f);
          }}
        />
      )}
      <div className="d-flex flex-column gap-1 mt-1">
        {images.map((im) => (
          <div key={im.id} className="small">
            <a href={im.image_url} target="_blank" rel="noreferrer">
              View
            </a>
            {!readOnly && (
              <button
                type="button"
                className="btn btn-link btn-sm text-danger p-0 ms-2"
                onClick={() => onDelete(im.id, aid)}
              >
                Remove
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default InspectionPhotoField;
